module.exports = __webpack_public_path__ + "img/bimbingan-approved.277e9248.png";